import { NotificationListResponse } from "../types";
import { API_BASE_URL } from "../config/api";
import { authenticatedFetch } from "./auth";

export const notificationService = {
  // Get notifications by user ID (Protected)
  getNotificationsByUserId: async (
    userId: string,
    page: number = 1,
    limit: number = 10,
    isRead?: boolean
  ): Promise<NotificationListResponse> => {
    try {
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      if (isRead !== undefined) {
        queryParams.append("isRead", isRead.toString());
      }

      const result = await authenticatedFetch<{
        success: boolean;
        data: NotificationListResponse;
      }>(
        `${API_BASE_URL}/notifications/user/${userId}?${queryParams.toString()}`,
        {
          method: "GET",
        }
      );

      if (result.success && result.data) {
        return result.data;
      }

      throw new Error("Failed to fetch notifications");
    } catch (error: any) {
      console.error("Failed to fetch notifications:", error);

      // Return empty state when API is not available
      return {
        notifications: [],
        pagination: {
          currentPage: 1,
          totalPages: 0,
          totalCount: 0,
          limit: limit,
          hasNextPage: false,
          hasPreviousPage: false,
        },
        unreadCount: 0,
      };
    }
  },

  // Mark notification as read (Protected)
  markAsRead: async (notificationId: string): Promise<void> => {
    try {
      await authenticatedFetch(
        `${API_BASE_URL}/notifications/${notificationId}/read`,
        {
          method: "PUT",
        }
      );
    } catch (error) {
      console.error("Failed to mark notification as read:", error);
      // Silently fail - not critical
    }
  },

  // Mark all notifications as read for a user (Protected)
  markAllAsRead: async (userId: string): Promise<void> => {
    try {
      await authenticatedFetch(
        `${API_BASE_URL}/notifications/user/${userId}/read-all`,
        {
          method: "PUT",
        }
      );
    } catch (error) {
      console.error("Failed to mark all notifications as read:", error);
      // Silently fail - not critical
    }
  },

  // Delete a notification (Protected)
  deleteNotification: async (notificationId: string): Promise<void> => {
    try {
      await authenticatedFetch(
        `${API_BASE_URL}/notifications/${notificationId}`,
        {
          method: "DELETE",
        }
      );
    } catch (error) {
      console.error("Failed to delete notification:", error);
      throw error;
    }
  },

  // Get unread count (Protected)
  getUnreadCount: async (userId: string): Promise<number> => {
    try {
      // Use the list endpoint which also returns unreadCount to avoid 404s
      const result = await notificationService.getNotificationsByUserId(
        userId,
        1,
        1
      );
      return typeof result.unreadCount === "number" ? result.unreadCount : 0;
    } catch (error) {
      console.error("Failed to fetch unread count:", error);
      // Return 0 if API is not available
      return 0;
    }
  },
};








